import InboxOutlined from 'assets/svg/InboxOutlined';
import { colorConstants } from 'config/colorConstants';
import { PPA_PACK_ARCH_TABLE_EMPTY } from 'constants/ppaTestIds';

import { TableEmptyState } from './PackArchitectureTable.styles';

type PackArchitectureTableEmptyStateProps = {
    title: string;
    description: string;
    minHeight: number;
};

const PackArchitectureTableEmptyState = ({
    title,
    description,
    minHeight,
}: PackArchitectureTableEmptyStateProps) => (
    <TableEmptyState $minHeight={minHeight} data-testid={PPA_PACK_ARCH_TABLE_EMPTY}>
        <div className="flex h-[61px] w-[96px] shrink-0 items-center justify-center">
            <InboxOutlined customIndex={0} stroke={colorConstants.greyAlt} />
        </div>
        <div className="flex flex-col items-center gap-1 text-center">
            <p
                className="m-0 text-base font-semibold leading-8"
                style={{ color: colorConstants.blackTransparent88 }}
            >
                {title}
            </p>
            <p className="m-0 text-sm font-normal leading-[22px]" style={{ color: colorConstants.greyAlt14 }}>
                {description}
            </p>
        </div>
    </TableEmptyState>
);

export default PackArchitectureTableEmptyState;
